// @mui
import { Box, Typography, Stack } from '@mui/material';
import useLocales from 'src/hooks/useLocales';
// assets
import { UploadIllustration } from '../../assets';

// ----------------------------------------------------------------------

export default function BlockContent() {
  const { translate: t } = useLocales();

  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      direction={{ xs: 'column', md: 'row' }}
      sx={{ width: 1, textAlign: { xs: 'center', md: 'left' } }}
    >
      <UploadIllustration sx={{ width: 220 }} />

      <Box sx={{ p: 3 }}>
        <Typography gutterBottom variant="h5">
          {t('Drop or Select file')}
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {t('drop files here or click')}&nbsp;
          <Typography
            variant="body2"
            component="span"
            sx={{ color: 'primary.main', textDecoration: 'underline' }}
          >
            {t('browse')}
          </Typography>
          &nbsp;{t('thorough your machine')}
        </Typography>
      </Box>
    </Stack>
  );
}
